<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 1" :class="{active: num == 1}">课程内容</li>
            <li @click="num = 0" :class="{active: num == 0}">麦语言</li>
            <!-- <li @click="num = 1" :class="{active: num == 1}">宽语言量化交易编写培训</li> -->
            <li @click="num = 2" :class="{active: num == 2}">相关产品 </li>
        </ul>
        <div class="details_gn" v-show="num == 1">
            <!-- <p class="detail_title">
                学员尊享：
            </p>
            <p>
                1、每位学员可享WT8实盘账号一个（有效期自开课日起三个月）；
            </p>
            <p>
                2、自课程结束日起6个月内，可免费参加一次同样课程的培训班（复训一次）。
            </p>
            <br> -->
            <p class="detail_title">
                注意事项：
            </p>
            <p>
                1、报名学员需要会看技术指标，能看懂指标公式。
            </p>
            <p>
                2、请自备笔记本电脑，教室内提供无线上网环境。
            </p>
            <p>
                3、因疫情防控，本次培训限制中高风险地区或途经中高风险地区学员参加。
            </p>
            <p>
                4、听课全程需佩戴口罩。
            </p>
            <br>
            <p class="detail_title">
                授课地址：
            </p>
            <p>
                北京市西城区西直门外大街德宝饭店，328会议室
            </p>
            <br>
            <p class="detail_title">
                课表：
            </p>
            <!-- <table style="width: 100%;" class="setsjtable">
                <tbody>
                    <tr>
                        <th style="width: 10%;">日期</th>
                        <th style="width: 20%;" class="timego">时间</th>
                        <th>课程内容</th>
                        <th>讲师</th>
                        <th style="width: 20%;">课程难度</th>
                    </tr>
                    <tr>
                        <td rowspan="5" align="center">8月6日<br>（周五）</td>
                        <td align="center" class="time">09:00--10:30</td>
                        <td>
                            <div class="td_b">第一讲：量化交易与机构投资 </div>
                        </td>
                        <td align="center">孙健</td>
                        <td align="center">理论知识</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">10:30--12:00</td>
                        <td>
                            <div class="td_w">第二讲：麦语言基本函数与语法</div>

                        </td>
                        <td align="center">陈雪</td>
                        <td align="center">编写难度★</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">13:30--15:30</td>
                        <td>
                            <div class="td_b">第三讲：如何把指标改写为交易模型</div>
                        </td>
                        <td align="center">关怀远</td>
                        <td align="center">编写难度★</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">15:30--17:00</td>
                        <td>
                            <div class="td_w">第四讲：跨指标模型的编写</div>
                        </td>
                        <td align="center">陈雪</td>
                        <td align="center">编写难度★</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">18:30--20:30</td>
                        <td>
                            <div class="td_b">编写练习、辅导</div>
                        </td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>
                    <tr>
                        <td rowspan="5" align="center">8月7日<br>（周六）</td>
                        <td align="center" class="time">09:00--10:30</td>
                        <td>
                            <div class="td_w">第五讲：跨周期模型的编写</div>
                        </td>
                        <td align="center">关怀远</td>
                        <td align="center">编写难度★★</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">10:30--12:00</td>
                        <td>
                            <div class="td_b">第六讲：分组指令的编写方法</div>
                        </td>
                        <td align="center">孙健</td>
                        <td align="center">编写难度★★</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">13:30--15:30</td>
                        <td>
                            <div class="td_w">第七讲：几种止损方案的编写方法</div>
                        </td>
                        <td align="center">关怀远</td>
                        <td align="center">编写难度★★</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">15:30--17:00</td>
                        <td>
                            <div class="td_b">第八讲：资金管理的编写</div>

                        </td>
                        <td align="center">孙健</td>
                        <td align="center">编写难度★★</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">18:30--20:30</td>
                        <td>
                            <div class="td_w">编写练习、辅导</div>
                        </td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>
                    <tr>
                        <td rowspan="4" align="center">8月8日<br>（周日）</td>
                        <td align="center" class="time">09:00--10:30</td>
                        <td>

                            <div class="td_b">第九讲：如何优化你的交易策略</div>
                        </td>
                        <td align="center">孙健</td>
                        <td align="center">编写难度★★★</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">10:30--12:00</td>
                        <td>
                            <div class="td_w">第十讲：IF THEN语句与全局变量</div>
                        </td>
                        <td align="center">关怀远</td>
                        <td align="center">编写难度★★★</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">13:30--15:30</td>
                        <td>
                            <div class="td_b">第十一讲：模型开发案例<br>
                                1、ATR趋势突破系统的改进<br>
                                2、黄金分割趋势策略的改进
                            </div>

                        </td>
                        <td align="center">孙健</td>
                        <td align="center">理论知识</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">15:30--17:00</td>
                        <td>
                            <div class="td_w">主题：十五年量化交易之路
                            </div>

                        </td>
                        <td align="center">特邀嘉宾 刘学伟</td>
                        <td align="center"></td>
                    </tr>
                </tbody>
            </table> -->
            <table>
                <tbody>
                    <tr>
                        <th>日期</th>
                        <th style="width: 20%;">时间</th>
                        <th>课程内容</th>
                        <th>讲师</th>
                    </tr>
                    <tr>
                        <td rowspan="5" align="center">10月29日<br>（周五）</td>
                        <td align="center" class="time">09:00--10:30</td>
                        <td>
                            <div class="td_b">案例1：均线趋势策略的改进<br>案例2：空中花园策略的改进</div>
                        </td>
                        <td align="center">谷学友</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">10:30--12:00</td>
                        <td>
                            <div class="td_w">案例3：标准正态化策略的改进<br>案例4：峰度偏度策略的改进</div>

                        </td>
                        <td align="center">韩龙哲</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">13:30--15:00</td>
                        <td>
                            <div class="td_b">案例5：葛兰维均线法则多周期策略的改进</div>
                            <div class="td_b">案例6：MACD顶底背离多周期策略的改进</div>
                        </td>
                        <td align="center">寇欣瑜</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">15:00--16:30</td>
                        <td>
                            <div class="td_w">案例7：自适应均线系统的改进</div>
                            <div class="td_w">案例8：自适应布林通道、自适应唐奇安通道策略的改进</div>
                        </td>
                        <td align="center">刘惠玉</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">夜课18:00--21:00</td>
                        <td>
                            <div class="td_b">课程疑点辅导及模型编写辅导</div>
                        </td>
                        <td align="center" style="padding-left:10px;padding-right:10px;">文华老师现场辅导</td>
                    </tr>
                    <tr>
                        <td rowspan="5" align="center">10月30日<br>（周六）</td>
                        <td align="center" class="time">09:00--10:30</td>
                        <td>
                            <div class="td_w">案例9：价量相关性策略的改进</div>
                            <div class="td_w">案例10：趋势启动策略的改进</div>
                        </td>
                        <td align="center">韩龙哲</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">10:30--12:00</td>
                        <td>
                            <div class="td_b">案例11： 量仓交易策略的改进</div>
                            <div class="td_b">案例12：基于阶段高低价突破策略的改进</div>
                        </td>
                        <td align="center">谷学友</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">13:30--15:00</td>
                        <td>
                            <div class="td_w">案例13：震荡器策略的改进（一）</div>
                            <div class="td_w">案例14：震荡器策略的改进（二）</div>
                        </td>
                        <td align="center">寇欣瑜</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">15:00--16:30</td>
                        <td>
                            <div class="td_b">打造高效率的期货交易系统</div>

                        </td>
                        <td align="center">特邀讲师 李烁</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">夜课18:00--21:00</td>
                        <td>
                            <div class="td_w">课程疑点辅导及模型编写辅导</div>
                        </td>
                        <td align="center">文华老师现场辅导</td>
                    </tr>
                    <tr>
                        <td rowspan="4" align="center">10月31日<br>（周日）</td>
                        <td align="center" class="time">09:00--10:30</td>
                        <td>
                            <div class="td_b">案例15：期望值策略的改进</div>
                            <div class="td_b">案例16：收益率策略的改进</div>
                        </td>
                        <td align="center">韩龙哲</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">10:30--12:00</td>
                        <td>
                            <div class="td_w">案例17：ATR趋势突破系统的改进</div>
                            <div class="td_w">案例18：黄金分割趋势策略的改进</div>
                        </td>
                        <td align="center">谷学友</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">13:30--15:00</td>
                        <td>
                            <div class="td_b">案例19：动量因子策略的改进</div>
                            <div class="td_b">案例20：均线偏离策略的改进</div>
                        </td>
                        <td align="center">刘惠玉</td>
                    </tr>
                    <tr>
                        <td align="center" class="time">15:00--16:30</td>
                        <td>
                            <div class="td_w">主观到量化的转型</div>

                        </td>
                        <td align="center">特邀讲师 杨庆泉</td>
                    </tr>
                </tbody>
            </table>
            <span style='font-size:14px;color:#670909;'>注：以上时间安排根据当天实际授课情况可能有些微调，每一讲中间休息15分钟。</span>
            <br>
            <br>
            <a href="https://www.wenhua.com.cn/popwin/wh3myy-42.htm" target="_blank">>>>查看更多内容 </a>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 0">
            <!-- <p style='text-indent:2em;'>
                随着国内期货市场的机构化发展，量化交易得到越来越多的关注与认可。量化交易已凭借其独有的魅力将投资者推向了新的时代！而对于量化门外的投资者来说虽对“量化交易”有无限向往，却苦于无从下手，而望而却步。量化是什么？策略是什么？模型是什么？如何实现自己的交易思路？！带着这些问题文华特举办本次模型编写培训班。
            </p>
            <p style='text-indent:2em;'>
                本次麦语言模型编写课程，由文华财经量化研究小组为大家精心设计，通过案例分析为投资者详解量化魅力所在，量化交易到底能帮投资者做什么等，对于如何编写模型，在课程中也会逐步深入提供从入门到精通的编写培训内容。
            </p> -->
            <p style='text-indent:2em;'>
                <common-data name="appFullName_11"/>（<common-data name="appShortName_11"/>）“麦语言”源于2004年文华推出的国内第一套量化函数库，经过17年的发展，吸收几十万用户的意见反馈，一点一点完善起来的，是一套成熟稳定的模型开发编程语言。麦语言，是国内使用人数最多的量化模型开发编程语言。
            </p>
            <p style='text-indent:2em;'>
                麦语言（My
                language）倡导的是积木式的编程理念，把复杂算法封装到一个个的函数里，采用"小语法，大函数"的构建模式，大幅提高编写效率，其他语言100多句的模型，用麦语言一般几句就可以编出来。麦语言的函数库，是经常更新的，根据客户的新要求随时添加新函数，来支持编程者的交易新思想和新应用。
            </p>
            <!-- <p style='text-indent:2em;'>
                培训第三天会针对三天所学内容进行现场考试，对于考试合格学员将由文华颁发麦语言培训毕业证书。
            </p>
            <p style='text-indent:2em;'>
                欢迎想学习麦语言模型编写，或对量化交易感兴趣的投资者报名参加！
            </p> -->
            <br>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <!-- <div class="details_gn" v-show="num == 1">
            <p>敬请期待...</p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div> -->
        <div class="details_gn" v-show="num == 2">
            <p style="display:block;"><b><common-data name="appFullName_11"/><common-data name="appShortName_11"/></b>：
                文华财经旗下的一款收费软件。针对机构和专业量化交易者而打造的一个专用交易软件，积木式编程语言、多模型组合回测、远程运行监控...
                <a target="_blank" style='display:inline;' href="https://wt8.wenhua.com.cn">了解更多</a></p>
            <!-- <p><b>库安算法交易软件WT9（宽语言）</b>：文华财经旗下的一款收费软件。针对交易量巨大的机构和大户打造的一个算法交易平台，支持把算法组件附加到手动交易、量化交易策略、套利交易的执行过程中，进行精细化控制，降低冲击成本，提高交易效率。软件还提供超长k线数据用于技术分析。
                <a target="_blank" href="https://wh9.wenhua.com.cn/">了解更多信息</a>
            </p> -->
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 1
            }
        },
    }
</script>
<style scoped>
    @import url('./doc.css');

    .details_gn {
        min-height: 140px;
    }

    .details_gn p {
        display: flex;
    }

    .details_gn a {
        font-size: 14px;
        display: flex;
    }

    .details_gn a:hover {
        text-decoration: none;
    }

    .info {
        font-size: 14px;
    }

    .info table {
        border: 1px solid #d1d7d7;
        border-collapse: collapse;
    }

    .info_2 {
        color: #646464;
        line-height: 180%;
        padding-bottom: 3px;
    }

    th {
        height: 35px;
        line-height: 35px;
        background: #a4bce2;
        color: #ffffff;
        border: 1px solid #d1d7d7;
        font-size: 14px;
        font-weight: normal;
    }

    td {
        padding: 0;
        border: 1px solid #d1d7d7;
    }

    td.time {
        color: #002c6f;
    }

    .td_w,
    .td_b {
        line-height: 29px;
        padding: 0 5px 0 22px;
        font-size: 14px;
        color: #646567;
        text-align: left;
    }

    .td_b {
        background: #eef0fd;
    }

    table {
        font-size: 14px;
    }
</style>